import { ClientService } from './client-service';
import { ClientServiceTypeEnum } from './client-service-type';

export class JetPassClientService extends ClientService {
  get clientServiceType(): ClientServiceTypeEnum {
    return ClientServiceTypeEnum.JetPass;
  }
}
